var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-placeholder"},_vm._l((_vm.rows),function(n){return _c('div',{key:n,staticClass:"skeleton",style:({ height: _vm.height + 'px' })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }